__turbopack_context__.v({
  "card": "CourseInformation-module__LusekG__card",
  "expandedContent": "CourseInformation-module__LusekG__expandedContent",
  "header": "CourseInformation-module__LusekG__header",
  "separator": "CourseInformation-module__LusekG__separator",
  "subtitle": "CourseInformation-module__LusekG__subtitle",
  "title": "CourseInformation-module__LusekG__title",
  "toggle": "CourseInformation-module__LusekG__toggle",
});
